module.exports = __webpack_public_path__ + "static/Logo-91598fab80f7ad981bbe3dbfaff3e14a.png";